import React, { ReactNode } from 'react'
import { ReactComponent as IconHome } from '../assets/svg/home.svg'
import { ReactComponent as IconPlush } from '../assets/svg/plus-circle.svg'
import { ReactComponent as IconReport } from '../assets/svg/query_stats.svg'
import { ReactComponent as IconUser } from '../assets/svg/user.svg'
import { ReactComponent as IconSetting } from '../assets/svg/settings.svg'
import { ReactComponent as IconTask } from '../assets/svg/task-list.svg'

export interface SidebarMenuInterface {
  title: string
  path: string
  icon: ReactNode
  isAdminOnly?: boolean
  childs: ChildInterface[]
}
export interface ChildInterface {
  title: string
  path: string
}

export const sidebarMenuList: SidebarMenuInterface[] = [
  {
    title: 'Home',
    path: '/',
    icon: <IconHome />,
    isAdminOnly: false,
    childs: [],
  },
  {
    title: 'Add',
    path: '/addnew',
    icon: <IconPlush />,
    isAdminOnly: false,
    childs: [],
  },
  {
    title: 'Tasks List',
    path: '#',
    icon: <IconTask />,
    isAdminOnly: false,
    childs: [
      {
        title: 'Task Middle Shift',
        path: '/tasks-list/middle',
      },
      {
        title: 'Task Night Shift',
        path: '/tasks-list/night',
      },
      {
        title: 'Task Public Area',
        path: '/tasks-list/public-area',
      },
    ],
  },
  {
    title: 'Report',
    path: '#',
    icon: <IconReport />,
    isAdminOnly: false,
    childs: [
      {
        title: 'Unreads Report',
        path: '/report/unread-report',
      },
      {
        title: 'Categories Report',
        path: '/report/category-report',
      },
      {
        title: 'Base Chapters Report',
        path: '/report/base-chapter-report',
      },
      {
        title: 'Chapters Report',
        path: '/report/chapter-report',
      },
    ],
  },
  {
    title: 'Users',
    path: '/user-management',
    icon: <IconUser />,
    isAdminOnly: true,
    childs: [],
  },
  {
    title: 'Setting',
    path: '#',
    icon: <IconSetting />,
    isAdminOnly: true,
    childs: [
      {
        title: 'Categories',
        path: '/setting/categories',
      },
      {
        title: 'Chapters',
        path: '/setting/chapters',
      },
      {
        title: 'Departments',
        path: '/setting/departments',
      },
      {
        title: 'Locations',
        path: '/setting/locations',
      },
      {
        title: 'Tasks Night Shift',
        path: '/setting/tasks-night-shift',
      },
      {
        title: 'Tasks Public Area',
        path: '/setting/tasks-public-area',
      },
    ],
  },
]
